module.exports = __webpack_public_path__ + "img/charisma.c5d698d7.svg";